import { headerAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const blackDuckContinuousDynamic = productVariant({
  identifier: "blackDuckContinuousDynamic",
  authLabel: "Continuous Dynamic",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://sentinel.whitehatsec.com/api"),
  auth: headerAuth([
    { name: "Key", value: { from: "secret", field: "apiKey" } },
  ]),
  steps: [
    {
      title: "Set up Black Duck Continuous Dynamic",
      items: [
        {
          kind: "markdown",
          content:
            "Open **My Profile → API Key** in the Continuous Dynamic portal and authenticate to display your Web API key. Enter it below with the API URL for your region. See [API authentication](https://apidocs.whitehatsec.com/whs/docs/authentication).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://sentinel.whitehatsec.com/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the documented Continuous Dynamic API host for the tenant. The official request example uses https://sentinel.whitehatsec.com/api; confirm the tenant’s assigned host with Black Duck if the account is region-specific.",
        },
        {
          kind: "input",
          label: "Web API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Generate the unique Web API key from the Continuous Dynamic Portal’s My Profile area and store it securely.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://sentinel.whitehatsec.com/api")
          .trim()
          .replace(/\/+$/, "") + "/whoami",
      ...{ method: "GET" },
    }),
  },
});
